import useImage from '../../hooks/useImage';

export const Logo: React.FC<{ name: string; type: string }> = ({
  name,
  type,
}): JSX.Element => (
  <img src={useImage(`logos/${name}.${type}`)?.image} alt="" />
);
